<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <h2>Redefinição de Senha</h2>
            <span>Informe sua nova senha e confirme.</span>
            <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{msg}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
              {{msgSuccess}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form class="signin-form" v-if="!passwordRedefined && !invalidToken">
              <div class="form-group">
                <label for="emailInput">E-mail</label>
                <input type="email" readonly class="form-control" id="emailInput" aria-describedby="emailHelp" v-model="username">
              </div>
              <div class="form-group">
                <label for="emailInput">Nova senha</label>
                <input type="password" class="form-control" id="passwordInput" aria-describedby="passwordHelp" placeholder="Digite uma nova senha" v-model="password">
                <small id="passwordHelp" class="form-text text-muted">Senha com no mínimo 6 dígitos, e uma letra maiúscula, uma minúscula e um número.</small>
              </div>
              <div class="form-group">
                <label for="emailInput">Confirmar nova senha</label>
                <input type="password" class="form-control" id="confirmPasswordInput" aria-describedby="passwordHelp" placeholder="Confirme a nova senha" v-model="confirmPassword">
              </div>
              <button type="submit" class="btn" v-on:click.stop.prevent="redefinePassword()">Confirmar</button>
            </form>
            <div v-if="invalidToken">
              <span>Token inválido. Clique <router-link to="/forgot-password">aqui</router-link> para redefinir a senha novamente.</span>
            </div>
            <div v-if="passwordRedefined">
              <span>Clique <router-link to="/login">aqui</router-link> para entrar.</span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'
import auth from '../services/auth'
import { API } from '../services/api'

export default {
  name: 'RedefinePassword',
  components: {
    Header,
    Footer,
    Loading,
    FontAwesomeIcon
  },
  data () {
    return {
      username: null,
      password: null,
      confirmPassword: null,
      passwordRedefined: false,
      invalidToken: false,
      showMsg: false,
      showMsgSuccess: false,
      msg: "",
      msgSuccess: "",
      loading: true,
      token: null
    }
  },
  mounted(){
    this.token = this.$route.params.token;
    console.log(this.token)
    this.loadUserFromToken();
  },
  methods: {
      loadUserFromToken () {
        //Exibe loading
        this.loading = true;
        this.$http.post(API.Auth.forgotPassword, {token: this.token, type: 'recover-profile'}).then((response) => {
          //Se usuário estiver autenticado, processa a sessão e redireciona para dashboard
          if(response.body.success == true){
            this.loading = false;
            this.username = response.body.username;
          }else{
            this.msg = response.body.message;
            this.showMsg = true;
            this.loading = false;
            this.invalidToken = true;
          }
          //Oculta loading
        }, (error) => {
          console.log(error);
          this.loading = false;
        });
      },
      redefinePassword(){
        this.hideMsg();
        this.loading = true;
        if(this.validate()){
          this.$http.post(API.Auth.forgotPassword, {username: this.username, token: this.token, password: this.password, confirmPassword: this.confirmPassword, type: 'redefine-password'})
          .then((response) => {
            if(response.body.success == true){
              this.passwordRedefined = true;
              this.msgSuccess = "Senha redefinida com sucesso! Efetue o seu login.";
              this.showMsgSuccess = true;
            }else{
              this.msg = response.body.message;
              this.showMsg = true;
            }
            this.loading = false;
          });
        }else{
          this.loading = false;
        }
      },
      validate(){
      var lowerCaseLetters = /[a-z]/g;
      var upperCaseLetters = /[A-Z]/g;
      var numbers = /[0-9]/g;
      if(this.username == '' || this.username == null){
        this.showMessage("Insira o seu email de usuário.");
        return false;
      }
      if(this.password == '' || this.password == null){
        this.showMessage("Insira uma senha válida.");
        return false;
      }
      if(!this.password.match(lowerCaseLetters) || !this.password.match(upperCaseLetters) || !this.password.match(numbers)){
        this.showMessage("Sua senha precisa ter ao menos um caractere maiúsculo, um minúsculo e um número.");
        return false;
      }
      if(this.password.length < 6){
        this.showMessage("Sua senha precisa ter ao menos 6 dígitos");
        return false;
      }
      if(this.confirmPassword == '' || this.confirmPassword == null){
        this.showMessage("Confirme a senha inserida.");
        return false;
      }
      if(this.confirmPassword !== this.password){
        this.showMessage("Senhas não conferem.");
        return false;
      }
      return true;
    },
    showMessage(msg){
        this.msg = msg;
        this.showMsg = true;
    },
    hideMsg(){
        this.msg = "";
        this.showMsg = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  a{
    text-decoration: none;
    color: #00ae39;
    font-family: RalewayBold;
  }

  h2{
    font-family: RalewayBold;
  }

  span{
    font-family: RalewayRegular;
  }

  .signin-form{
    width: 100%;
    padding: 20px;
    background-color: #eee;
    border-radius: 5px;
    margin-bottom: 40px;
    font-family: RalewayRegular;
    margin-top: 30px;

    h5{
      position: relative;
      text-align: center;
      margin: 30px 0px;
      font-family: RalewayRegular;

      &::before{
        position: absolute;
        content: " ";
        width: 35%;
        border-bottom: 1px solid #d9d9d9;
        height: 1px;
        top: 50%;
        right: 0;
      }

      &::after{
        position: absolute;
        content: " ";
        width: 35%;
        border-bottom: 1px solid #d9d9d9;
        height: 1px;
        top: 50%;
        left: 0;
      }
    }

    small{
      a{
        font-size: 14px;
        color: #00ae39;
        font-family: RalewayBold;
        text-decoration: none;
      }
    }

    input{
      padding: 10px;
      border-color: #00ae39;
    }

    .form-check{
      padding-bottom: 10px;
    }

    button{
      width: 100%;
      margin-top: 20px;
      padding: 10px;
      font-size: 20px;
      background-color: #00ae39;
      color: #fff;
      cursor: pointer;

      &.login-facebook{
        background-color: #3b5998;
        border: none;
        border-radius: 5px;

        svg{
          margin-left: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RedefinePassword.vue